import React from 'react';

import { Badge } from './ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

interface LearningRecommendationsProps {
  recommendations: string[];
  learningStyle?: string;
}

export const LearningRecommendations: React.FC<LearningRecommendationsProps> = ({ 
  recommendations = [],
  learningStyle 
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Learning Recommendations</CardTitle>
        {learningStyle && (
          <Badge variant="secondary">{learningStyle} Learner</Badge>
        )}
      </CardHeader>
      <CardContent>
        {recommendations.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No recommendations available</p>
        ) : (
          <div className="space-y-3">
            {recommendations.map((recommendation, index) => (
              <div key={index} className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <p className="text-sm">{recommendation}</p>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}; 